module.exports = {
      id: "crown-usage",
      viewBox: "0 0 19 19",
      url: __webpack_public_path__ + "svg-sprite.svg#crown",
      toString: function () {
        return this.url;
      }
    }